<div class="age-fields" [class.age-fields--compact]="compact">
  <label class="age-fields__unit">
    <span class="age-fields__label">Yr</span>
    <input
      class="age-fields__input"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      [disabled]="disabled"
      [value]="years ?? ''"
      (input)="onYearsInput($event)"
      placeholder="0"
      aria-label="Age in years"
    />
  </label>
  <label class="age-fields__unit">
    <span class="age-fields__label">Mo</span>
    <input
      class="age-fields__input"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      [disabled]="disabled"
      [value]="months ?? ''"
      (input)="onMonthsInput($event)"
      placeholder="0"
      aria-label="Age in months"
    />
  </label>
  <label class="age-fields__unit">
    <span class="age-fields__label">Day</span>
    <input
      class="age-fields__input"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      [disabled]="disabled"
      [value]="days ?? ''"
      (input)="onDaysInput($event)"
      placeholder="0"
      aria-label="Age in days"
    />
  </label>
  <span class="age-fields__preview" *ngIf="showPreview && previewLabel !== '—'">
    {{ previewLabel }}
  </span>
</div>
